import { Component  } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-resumen-liquidacion',
  templateUrl: './resumen-liquidacion.component.html',
  styleUrls: ['./resumen-liquidacion.component.scss']
})
export class ResumenLiquidacionComponent   {
  
  user:any;
  flag:boolean = true;
  constructor(private loginService:LoginService) { 
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.flag = (this.user.id_roles == 45)? false: true;
  }


  
  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
